import { t } from 'ttag';

export const WEEKDAYS = () => [
    // TRANS: Full names of weekdays
    t`MONDAY`,
    t`TUESDAY`,
    t`WEDNESDAY`,
    t`THURSDAY`,
    t`FRIDAY`,
    t`SATURDAY`,
    t`SUNDAY`,
];

export const WEEKDAYS_SHORT = () => [
    // TRANS: Short variations of weekday names. Preferably ~3 letters
    t`MON`,
    t`TUE`,
    t`WED`,
    t`THU`,
    t`FRI`,
    t`SAT`,
    t`SUN`,
];

export const MONTHS = i => [
    // TRANS: Short variations of the names of months. Preferably ~3 letters
    t`JAN`,
    t`FEB`,
    t`MAR`,
    t`APR`,
    t`MAY`,
    t`JUN`,
    t`JUL`,
    t`AUG`,
    t`SEP`,
    t`OCT`,
    t`NOV`,
    t`DEC`,
][i];
